import { useEffect, useState } from 'react';
import styles from './ScoreBar.module.css';

interface CounterProps {
  value: number;
  color: string;
  strokeColor: string;
}

export const Counter = ({ value, color, strokeColor }: CounterProps) => {
  const [currentValue, setCurrentValue] = useState(value);
  const [isFlipping, setIsFlipping] = useState(false);

  useEffect(() => {
    if (value !== currentValue) {
      setIsFlipping(true);
      const timer = setTimeout(() => {
        setCurrentValue(value);
        setIsFlipping(false);
      }, 700);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [value, currentValue]);

  return (
    <div className={styles.scoreWrapper}>
      <div 
        className={styles.counter} 
        style={{ 
          '--counter-color': color,
          '--digit-stroke-color': strokeColor,
        } as React.CSSProperties}
      >
        <div 
          className={`${styles.digit} ${styles.digitCurrent} ${isFlipping ? styles.exiting : ''}`}
        >
          {currentValue}
        </div>
        {isFlipping && (
          <div className={`${styles.digit} ${styles.digitNext}`}>
            {value}
          </div>
        )}
      </div>
    </div>
  );
};
